<script>
  import { user, validkey, readServices } from "../stores/user";
  import { searchDoc, panelController, modalS } from "../stores/service";
  import {loginService, inicializarvistas} from "../Controller/user/Login";
  import { navigate } from "svelte-routing";
  import { auth, provider } from "../firebase";
  import { ValidView } from "./../Controller/user/Login";
  import  Landing_content  from "../views/Landing_content/Landing_content.svelte";
  import { onMount } from "svelte";
  
  document.title = "Ratingg | Inicia sesión";

  const procesarFormulario = async () => {

    $panelController.viewLogin.controllers.txt.mess = "Validando";
    $panelController.viewLogin.controllers.btn[0].status = false;
    $panelController.viewLogin.controllers.btn[1].status = false;
    $panelController.viewLogin.controllers.btn[2].status = false;

    try {
      
     /*  $panelController.firebase.load = false; */
      const res = await auth.signInWithPopup(provider);

      user.setUser(res.user);
      loginService({email:$user.email, photoURL:$user.photoURL,displayName:$user.displayName});
      return { status: true, user: res.user };

    } catch (error) {

      $panelController.viewLogin.controllers.txt.mess =
        "Ocurrió un error, vuelva a intentarlo";

      $panelController.viewLogin.controllers.btn[0].status = true;

      $panelController.viewLogin.controllers.btn[1].status = false;

      $panelController.viewLogin.controllers.btn[2].status = false;

      return { status: false, error: error };
    }
  };
 
  onMount(async () => {
    
    /* console.log($panelController.viewLogin); */
    if (!$panelController.viewLogin.nav) {
      /* Error, acceso no permitido */
    }

    if (!$panelController.viewLogin.false) {
      inicializarvistas();
    }


    if ($panelController.viewLogin.status) {
      switch ($panelController.viewLogin.roluser) {
        case 1:
          /* admin */

          ValidView("admin");
          if ($panelController.service.service.mode == 1) {
            $panelController.viewMesas.nav = true;
          }
          startServicesRealTime();

          /* Home for a signed-in admin: live tables for restaurants,
             otherwise the statistics. (/config has no page of its own.) */
          navigate(
            $panelController.service.service.mode == 1
              ? "/mesas"
              : "/MainAnalytics/menu",
            { replace: true },
          );

          break;
        case 2:
          /* nuevo usuario */

          $panelController.viewConfiguracion.nav = false;
          $modalS.reset();
          $modalS.info.title = "Aviso";
          $modalS.info.body = `Bienvenido a ratingg, Ya leiste nuestra política de privacidad`;
          $modalS.controllers.btn[0].text = `Estoy de acuerdo, crear cuenta`;
          $modalS.controllers.btn[0].status = true;
          $modalS.controllers.btn[1].text = `Leer políticas de privacidad`;
          $modalS.controllers.btn[1].status = true;
          $modalS.controllers.btnClose = false;
          $modalS.mostrar();
          let modal = await $modalS.mostrar();
          if (modal) {
            ValidView("nuevoUsuario");

            navigate("/config", { replace: true });
          } else {
            navigate("/politicas", { replace: true });
            loggin();
          }
          break;
        case 3:
          /* muestra */

          muestra();

          ValidView("muestra");
          break;
        case 4:
          /* login */
          loggin();
          ValidView("login");
          break;

        case 4:
          /* colaborador */
          ValidView("colaborador");
          -navigate("/main-ratinggs", { replace: true });
          break;

        default:
          break;
      }
    }
  });

  async function startServicesRealTime() {
    try {
      let data = await readServices({
        collection: "service",
        id: $panelController.firebase.docs[0].id,
      });
    } catch (error) {
      $modalS.reset();
      $modalS.info.title = "Aviso";
      $modalS.info.body = `Se perdió la conexión o es inestable por lo que recargue o inténtelo mas tarde`;
      $modalS.controllers.btn[0].status = false;
      $modalS.controllers.btn[1].text = `Aceptar`;
      $modalS.controllers.btn[1].status = true;
      $modalS.controllers.btnClose = false;
      $modalS.mostrar();
      let modal = await $modalS.mostrar();
    }
  }

  async function muestra(value) {
    
    const datan = await searchDoc({
      collection: "service",
      data: ["idServices", "==", $panelController.viewLogin.url.id],
    });
    
    if (datan.status) {
      datan.search = datan.data[0].doc.listRatinggs.find(
        (item) => item.config.id == $panelController.viewLogin.url.key
      );

      if (datan.search) {
        $panelController.service = datan.data[0].doc;
        $panelController.firebase.idservice = datan.data[0].id;
        $panelController.firebase.docs[0].id = datan.data[0].id;

        
        $panelController.viewEvaluacion.index[0] =
          datan.data[0].doc.listRatinggs.indexOf(datan.search);

        controller(2);
      }
    } else {
      $modalS.reset();
      $modalS.info.title = "Aviso";
      $modalS.info.body = `No se encontró el ratingg.`;
      $modalS.controllers.btn[0].text = `Aceptar`;
      $modalS.controllers.btn[0].status = true;
      let respues = await $modalS.mostrar();
      loggin();
    }
  }

  function loggin(value) {
    $panelController.viewLogin.controllers.txt.mess =
      "Inicia sesión para enviar el rating";
    $panelController.viewLogin.controllers.btn[0].status = true;
    $panelController.viewLogin.controllers.btn[1].status = false;
    $panelController.viewLogin.controllers.btn[2].status = false;
  }

  async function controller(main) {
    switch (main) {
      case 1:
        procesarFormulario();
        break;
      case 2:
        if (
          $panelController.service.listRatinggs[
            $panelController.viewEvaluacion.index[0]
          ].config.login
        ) {
          await user.current();
          if ($user) {
            controller(3);
          } else {
            $panelController.viewLogin.controllers.txt.mess =
              "Inicia sesión para enviar el rating";
            $panelController.viewLogin.controllers.btn[0].status = true;
            $panelController.viewLogin.controllers.btn[1].status = false;
            $panelController.viewLogin.controllers.btn[2].status = false;
          }
        } else {
          controller(3);
        }

        break;
      case 3:
        if (
          $panelController.service.listRatinggs[
            $panelController.viewEvaluacion.index[0]
          ].config.key[0]
        ) {
          $panelController.viewLogin.controllers.txt.mess = "";
          $modalS.reset();
          $modalS.info.title = "Ingresar";
          $modalS.info.body = `Esta protegido ${
            $panelController.service.listRatinggs[
              $panelController.viewEvaluacion.index[0]
            ].config.name
          }, escribe el PIN para continuar `;
          $modalS.controllers.btn[0].text = `Aceptar`;
          $modalS.controllers.btn[1].text = `No, cancelar`;
          $modalS.controllers.btn[0].status = true;
          $modalS.controllers.btn[1].status = true;
          $modalS.controllers.input.status = true;
          $modalS.controllers.btnClose = false;
          $modalS.controllers.input.placeholder = "PIN";
          let validPIN = true;
          do {
            let modal = await $modalS.mostrar();
            if (modal) {
              if (
                $modalS.controllers.input.value ==
                $panelController.service.listRatinggs[
                  $panelController.viewEvaluacion.index[0]
                ].config.key[1]
              ) {
                validPIN = false;
                controller(4);
              } else {
                $modalS.info.title = "Ingresar";
                $modalS.info.body = "No es correcto";
                $modalS.controllers.input.status = true;
                $modalS.controllers.input.value = "";
                $modalS.controllers.input.placeholder = "PIN";
              }
            } else {
              validPIN = false;
              $panelController.viewLogin.controllers.txt.mess =
                "Pulsa continuar para enviar el rating";
              $panelController.viewLogin.controllers.btn[0].status = false;
              $panelController.viewLogin.controllers.btn[1].status = true;
            }
          } while (validPIN);
        } else {
          controller(4);
        }

        break;
      case 4:
        startServicesRealTime();
        navigate("/evaluacion", { replace: true });

        break;

      default:
        break;
    }
  }

  function detenerCamara() {
    if (stream) {
      const tracks = stream.getTracks();
      tracks.forEach((track) => track.stop());
    }
  }

  function roughSizeOfObject(object) {
    var objectList = [];
    var stack = [object];
    var bytes = 0;

    while (stack.length) {
      var value = stack.pop();

      if (typeof value === "boolean") {
        bytes += 4;
      } else if (typeof value === "string") {
        bytes += value.length * 2;
      } else if (typeof value === "number") {
        bytes += 8;
      } else if (
        typeof value === "object" &&
        objectList.indexOf(value) === -1
      ) {
        objectList.push(value);

        for (var i in value) {
          stack.push(value[i]);
        }
      }
    }
    return bytes;
  }



</script>
<svelte:head>
  <link rel="preconnect" href="https://fonts.googleapis.com">
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
  <link href="https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,400;9..144,500;9..144,600;9..144,700&family=DM+Sans:wght@400;500;600;700&display=swap" rel="stylesheet">
</svelte:head>

<div class="ratingg-page">
  <div class="ratingg-hero">
    <div class="ratingg-hero__brand">
      <span class="ratingg-hero__dots" aria-hidden="true"><i></i><i></i><i></i></span>
      <span class="ratingg-hero__word">ratingg</span>
    </div>
    <h1 class="ratingg-hero__title">¡Bienvenido!</h1>
    {#if $panelController.service.name}
      <p class="ratingg-hero__service">{$panelController.service.name}</p>
    {/if}
    <p class="ratingg-hero__message">
      {$panelController.viewLogin.controllers.txt.mess}
    </p>
    <div class="ratingg-hero__actions">
      {#each $panelController.viewLogin.controllers.btn as btn}
        {#if btn.status}
          <button
            class="ratingg-btn"
            on:click={() => {
              controller(btn.opc);
            }}
          >
            {btn.text}
          </button>
        {/if}
      {/each}
    </div>
  </div>

  <Landing_content />
</div>

<style>
  .ratingg-page {
    background: #fbf6ea;
    min-height: 100vh;
  }

  .ratingg-hero {
    max-width: 30rem;
    margin: 0 auto;
    padding: 4.5rem 1.5rem 3.5rem;
    text-align: center;
    font-family: "Fraunces", ui-serif, Georgia, serif;
  }

  .ratingg-hero__brand {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 2rem;
  }

  .ratingg-hero__dots {
    display: inline-flex;
    gap: 5px;
  }

  .ratingg-hero__dots i {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: block;
  }

  .ratingg-hero__dots i:nth-child(1) {
    background: #7e934e;
  }

  .ratingg-hero__dots i:nth-child(2) {
    background: #eec13b;
  }

  .ratingg-hero__dots i:nth-child(3) {
    background: #e2703f;
  }

  .ratingg-hero__word {
    font-size: 1.7rem;
    font-weight: 600;
    color: #2c3320;
  }

  .ratingg-hero__title {
    font-size: 2.2rem;
    font-weight: 600;
    color: #2c3320;
    margin: 0 0 0.5rem;
  }

  .ratingg-hero__service {
    font-family: "DM Sans", system-ui, -apple-system, sans-serif;
    font-size: 1.05rem;
    color: #7e934e;
    font-weight: 600;
    margin: 0 0 0.75rem;
  }

  .ratingg-hero__message {
    font-family: "DM Sans", system-ui, -apple-system, sans-serif;
    font-size: 1rem;
    color: #4a5240;
    margin: 0 0 2rem;
  }

  .ratingg-hero__actions {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }

  .ratingg-btn {
    font-family: "DM Sans", system-ui, -apple-system, sans-serif;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.6rem;
    border: none;
    border-radius: 999px;
    padding: 0.9rem 1.6rem;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    background: #2c3320;
    color: #fbf6ea;
    transition: transform 0.15s ease, background 0.15s ease;
  }

  .ratingg-btn:hover {
    background: #3a4429;
    transform: translateY(-1px);
  }
</style>
